import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { BaseInjectorService } from 'src/app/base/base-service.injector';

@Component({
    selector: 'app-challenge-popup',
    templateUrl: './challenge-popup.component.html',
    styleUrls: ['./challenge-popup.component.scss'],
    standalone: false
})
export class ChallengePopupComponent extends BaseInjectorService implements OnInit {

  @Input() popupDetails : any;

  constructor(private modalCtrl: ModalController) { 
    super();
  }

  ngOnInit() {
    console.log(this.popupDetails);
  }


  closePopup(){
    this.modalCtrl.dismiss();
  }
}
